import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

import ShareTitleListPageBody from './components/ShareTitleListPageBody';
import { useShareTitleListPage } from './context/ShareTitleListPageContext';

const ShareTitleList: FC = () => {
  const { t } = useTranslate();

  const { data } = useShareTitleListPage();

  return (
    <Page>
      <PageListHeader
        subTitle={t('TitleRegistryBook')}
        description={`${data.societyName} ${t('HaveActiveShareTitles', {
          count: data.activeShareTitleTotal,
          totalCount: data.shareTitleTotal,
        })}`}
        actions={[]}
      />

      <ShareTitleListPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default ShareTitleList;
